import { motion } from 'framer-motion';
import { AlertCircle, Info, CheckCircle2 } from 'lucide-react';
import type { ReactNode } from 'react';

const ICONS = {
  danger: <AlertCircle className="w-5 h-5 text-destructive" />,
  info: <Info className="w-5 h-5 text-muted-foreground" />,
  success: <CheckCircle2 className="w-5 h-5 text-success" />,
};

const TONE_CLASSES = {
  danger: 'bg-destructive/10 border-destructive/20 text-destructive',
  info: 'bg-muted border-border text-foreground',
  success: 'bg-success/10 border-success/20 text-success',
};

export function Alert({
  tone = 'info',
  children,
}: {
  tone?: 'danger' | 'info' | 'success';
  children: ReactNode;
}): JSX.Element {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      className={`flex items-start gap-3 p-4 rounded-2xl border ${TONE_CLASSES[tone]}`}
      role={tone === 'danger' ? 'alert' : 'status'}
    >
      <div className="shrink-0 mt-0.5">{ICONS[tone]}</div>
      <div className="text-sm leading-relaxed">{children}</div>
    </motion.div>
  );
}
